import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const dailyTrendRowSchema = z.object({
  date: z.string(),
  uniqueUsers: z.number(),
  totalReviews: z.number(),
  passed: z.number(),
  failed: z.number(),
  skipped: z.number(),
  totalTimeSpent: z.number(),
});

const learningStatsDataSchema = z.object({
  dailyTrend: z.array(dailyTrendRowSchema),
  topChallenges: z.array(
    z.object({
      challengeId: z.number(),
      title: z.string(),
      reviewCount: z.number(),
    }),
  ),
  hardestChallenges: z.array(
    z.object({
      challengeId: z.number(),
      title: z.string(),
      failRate: z.number(),
      totalAttempts: z.number(),
    }),
  ),
  deviceStats: z.array(z.object({ device: z.string(), count: z.number() })),
  levelDistribution: z.array(z.object({ level: z.number(), count: z.number() })),
});

export type IGetLearningStatsData = z.infer<typeof learningStatsDataSchema>;

export const getLearningStatsResponseSchema = createApiResponseSchema(
  learningStatsDataSchema,
) as z.ZodSchema<IAPI<IGetLearningStatsData>>;

export type IGetLearningStatsResponse = IAPI<IGetLearningStatsData>;
